var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.96735 2.31929C6.16631 2.31929 3.949 4.48924 3.949 7.06237V9.81124C3.949 9.97716 3.89959 10.1393 3.80709 10.2771L2.44976 12.2982L2.44077 12.3113C2.28459 12.5347 2.3017 12.7385 2.3823 12.8851C2.46607 13.0376 2.6492 13.1799 2.9442 13.1799H15.0753C15.2879 13.1799 15.494 13.0533 15.6091 12.8484C15.7189 12.6526 15.7023 12.4745 15.5992 12.3393C15.5938 12.3322 15.5884 12.325 15.5832 12.3178L14.1411 10.2965C14.04 10.1549 13.9857 9.98526 13.9857 9.81124V7.06237C13.9857 5.77113 13.4136 4.53687 12.56 3.71706C11.5898 2.86831 10.3431 2.31929 8.96735 2.31929ZM2.27874 7.06237C2.27874 3.49106 5.32107 0.648438 8.96735 0.648438C10.8092 0.648438 12.442 1.38818 13.6756 2.47347C13.684 2.4808 13.6922 2.48829 13.7002 2.49595C14.8761 3.61656 15.656 5.28738 15.656 7.06237V9.54365L16.9358 11.3374C17.5016 12.0892 17.4414 12.9965 17.0654 13.6663C16.6926 14.3305 15.9655 14.8507 15.0753 14.8507H2.9442C1.13849 14.8507 -0.0212436 12.9276 1.06733 11.3605L2.27874 9.5566V7.06237ZM5.66258 16.5216C5.66258 16.0602 6.03648 15.6861 6.49771 15.6861H11.5085C11.9697 15.6861 12.3436 16.0602 12.3436 16.5216C12.3436 16.983 11.9697 17.357 11.5085 17.357H6.49771C6.03648 17.357 5.66258 16.983 5.66258 16.5216Z",
    fill: "#1890FF",
    stroke: "#1890FF",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.a287c8465742f33892177b9962b9d5f4.svg";
export { ForwardRef as ReactComponent };